import { render, staticRenderFns } from "./marketFunds.vue?vue&type=template&id=54dac6d7&scoped=true&"
import script from "./marketFunds.vue?vue&type=script&lang=js&"
export * from "./marketFunds.vue?vue&type=script&lang=js&"
import style0 from "./marketFunds.vue?vue&type=style&index=0&id=54dac6d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dac6d7",
  null
  
)

export default component.exports